import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioLabelWrapperFn = /* @__PURE__ */ createRecipe('radio-label-wrapper', {}, [])

const radioLabelWrapperVariantMap = {}

const radioLabelWrapperVariantKeys = Object.keys(radioLabelWrapperVariantMap)

export const radioLabelWrapper = /* @__PURE__ */ Object.assign(memo(radioLabelWrapperFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioLabelWrapper',
  __getCompoundVariantCss__: radioLabelWrapperFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioLabelWrapperVariantKeys,
  variantMap: radioLabelWrapperVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioLabelWrapperVariantKeys)
  },
  getVariantProps: radioLabelWrapperFn.getVariantProps,
})